import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  InputGroup,
  InputGroupText,
} from "reactstrap";

class ChangeUserNameModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.initialState;
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  initialState = {
    userId: this.props.userId,
    username: this.props.username,
    password: "",
  };

  componentDidUpdate(prevProps) {
    if (prevProps.username != this.props.username) {
      this.setState({
        username: this.props.username,
      });
    }
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value,
    });
  }

  changeUserName(e) {
    e.preventDefault();
    this.props.handleSubmit(this.state);
    this.setState(this.initialState);
  }

  render() {
    let { open, toggle, userName } = this.props;
    let { username } = this.state;
    return (
      <>
        <Modal isOpen={open} fade={false} toggle={toggle}>
          <ModalHeader toggle={toggle}>Đổi tên người dùng</ModalHeader>
          <ModalBody>
            <div class="row">
              <div class="col-md-12">
                <span class="text-danger">Error message goes here!</span>
                <Form onSubmit={(e) => this.changeUserName(e)}>
                  <FormGroup>
                    <Label>Tên đăng nhập</Label>
                    <Input
                      onChange={this.handleInputChange}
                      type="text"
                      required
                      value={username}
                      name="username"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label>Mật khẩu hiện tại</Label>
                    <Input
                      onChange={this.handleInputChange}
                      type="password"
                      required
                      placeholder="**********"
                      name="password"
                    />
                  </FormGroup>
                  <Button className="mb-2 me-2" type="submit">
                    Đồng ý
                  </Button>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </>
    );
  }
}

export default ChangeUserNameModal;
